<template>
  <section class="container mt-80">
    <!------title------->
    <div
      class="sectionTitle pt-60 pb-15 border-bottom-dark purchases"
      data-aos="fade-up"
      :data-aos-delay="200"
    >
      <h1 class="sectionTitle__title">Wishlist</h1>
      <p class="sectionTitle__text">
        Empowering learners with exceptional features tailored for growth.
      </p>
    </div>
    <!------in case Whish list has Content----------->
    <div class="whislist-content pt-40">
      <div class="row">
        <div
          class="col-lg-3 col-md-6"
          data-aos="fade-up"
          :data-aos-delay="250"
          v-for="i in 3"
          :key="i"
        >
          <coursecard :showPrice="true" />
        </div>
      </div>
    </div>
    <!----------------->

    <!-------in case wishlist is Empty------------------>
    <div class="empty-wishlist d-none">
      <section>
        <div class="sectionTitle text-center pt-60">
          <h1 class="sectionTitle__title text-black">No Favorites Yet</h1>
          <p class="sectionTitle__text text-black">
            Save courses you love to your Wishlist for quick access later!
          </p>
        </div>
        <div
          class="pt-60 pb-40 d-flex justify-center align-items-center flex-column"
        >
          <div class="mb-40">
            <img
              src="../../assets/images/home/heart.png"
              width="184"
              height="184"
              alt="heart logo"
            />
          </div>
          <button class="main-button" style="width: 250px">
            Start Exploring
          </button>
        </div>
      </section>

      <!----Top trending courses----------------->

      <TrendingCourse />

      <!----end of trending Courses----------------->
    </div>
    <!--end of empty wishlist--->
  </section>
</template>
<script>
import Coursecard from "../common/Coursecard.vue";
import TrendingCourse from "../Homepage/TrendingCourse.vue";
import AOS from "aos";
export default {
  components: {
    TrendingCourse,
    Coursecard,
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
